module.exports = __webpack_public_path__ + "img/background.15cbcd36.png";